var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isFetching) ? _c('pricing', {
    attrs: {
      "onCreatePayment": _vm.createPayment,
      "profileTariff": _vm.tariff,
      "tariffs": _vm.tariffs,
      "products": _vm.products,
      "balance": _vm.balance,
      "is-filled": _vm.isFilled,
      "is-identified": _vm.isIdentified
    }
  }) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6607028b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/pricing/PricingContainer.vue
// module id = 1016
// module chunks = 0